import { ELocations } from '../types';
import { useAppSelector } from './useRedux';

export const useLocationPermissions = () => {
  const locations = useAppSelector((state) => state.user.permissions?.locationPermission);

  const hasLocationPermissions = (perms: ELocations[]) => {
    if (!locations) {
      return false;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const location of perms) {
      const hasLocation = locations.find((value) => value === location);
      if (!hasLocation) {
        return false;
      }
    }

    return true;
  };

  return { hasLocationPermissions };
};
